import { render, staticRenderFns } from "./LivePayDetails.vue?vue&type=template&id=e55fadda"
import script from "./LivePayDetails.vue?vue&type=script&lang=ts"
export * from "./LivePayDetails.vue?vue&type=script&lang=ts"
import style0 from "./LivePayDetails.vue?vue&type=style&index=0&id=e55fadda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports